module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/modules/_fails.js
// module id = 1351
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16